import styled from 'styled-components'
import {textAlign} from 'styled-system'
import typography from 'lib/style/typography'

const H1 = styled.h1`
  ${typography};
  ${textAlign};
  margin: 0;
  font-weight: 300;
  font-size: 1.5rem;
`

export default H1
